import { Callback } from '../../../types';
import { isMobile } from '../../../utils';
import Video, { ConnectOptions, LocalTrack, Room } from 'twilio-video';
import { VideoRoomMonitor } from '@twilio/video-room-monitor';
import { useCallback, useEffect, useRef, useState } from 'react';

export {};
declare global {
  interface Window {
    twilioRoom?: Room;
  }
}
// @ts-ignore
window.TwilioVideo = Video;

export default function useRoom(localTracks: LocalTrack[], onError: Callback, options?: ConnectOptions) {
  const [room, setRoom] = useState<Room | null>(null);
  const [isConnecting, setIsConnecting] = useState(false);
  const optionsRef = useRef(options);

  useEffect(() => {
    // This allows the connect function to always access the most recent version of the options object. This allows us to
    // reliably use the connect function at any time.
    optionsRef.current = options;
  }, [options]);

  const connect = useCallback(
    token => {
      setIsConnecting(true);
      console.log('▶️ Connecting with token:', token);
      console.log('📹 Local tracks:', localTracks);
      return Video.connect(token, {
        ...optionsRef.current,
        tracks: localTracks,
      }).then(
        newRoom => {
          setRoom(newRoom);
          console.log('✅ Connected to Twilio Room:', newRoom);

          VideoRoomMonitor.registerVideoRoom(newRoom);
          const disconnect = () => newRoom.disconnect();

          newRoom.setMaxListeners(16);

          newRoom.once('disconnected', () => {
            setTimeout(() => setRoom(null));
            window.removeEventListener('beforeunload', disconnect);
            if (isMobile) {
              window.removeEventListener('pagehide', disconnect);
            }
          });

          // Save to global (optional)
          window.twilioRoom = newRoom;

          newRoom.localParticipant.videoTracks.forEach(publication => publication.setPriority('low'));

          setIsConnecting(false);

          window.addEventListener('beforeunload', disconnect);
          if (isMobile) {
            window.addEventListener('pagehide', disconnect);
          }

          // return newRoom; // ✅ FIXED: return Room
        },
        error => {
          onError(error);
          setIsConnecting(false);
          throw error; // ⚠️ good to re-throw for external handling
        }
      );
    },
    [localTracks, onError]
  );

  return { room, isConnecting, connect };
}
